import { render, staticRenderFns } from "./PreviewSegmentsList.vue?vue&type=template&id=45f9278b&"
import script from "./PreviewSegmentsList.vue?vue&type=script&lang=js&"
export * from "./PreviewSegmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports